var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M7.4616 1V9.72804L5.15004 7.32402L4.38854 8.11598L8.00006 11.872L11.6116 8.11598L10.8501 7.32402L8.53852 9.72804V1H7.4616ZM2.07692 12.2H1V15H15V12.2H13.9231V13.88H2.07692V12.2Z","fill":_vm.fill}})])
}
var staticRenderFns = []

export { render, staticRenderFns }